/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Conversation } from '../model';
// @ts-ignore
import type { ConversationMessage } from '../model';
// @ts-ignore
import type { ConversationQueryRequest } from '../model';
// @ts-ignore
import type { ConversationQueryResponse } from '../model';
// @ts-ignore
import type { ConversationRetryRequest } from '../model';
// @ts-ignore
import type { ConversationRetryResponse } from '../model';
// @ts-ignore
import type { ConversationSummary } from '../model';
// @ts-ignore
import type { EditConversation } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { MentionConceptType } from '../model';
// @ts-ignore
import type { MentionSearchResponse } from '../model';
// @ts-ignore
import type { StreamConversation200Response } from '../model';
// @ts-ignore
import type { TempEvidenceResponse } from '../model';
/**
 * ModulosAssistantApi - axios parameter creator
 */
export const ModulosAssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create temporary evidence from a conversation message.
         * @summary Create Temp Evidence For Conversation
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidenceForConversation: async (conversationId: string, messageId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('createTempEvidenceForConversation', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('createTempEvidenceForConversation', 'messageId', messageId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTempEvidenceForConversation', 'projectId', projectId)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}/messages/{message_id}/temp-evidence`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{message_id}', encodeURIComponent(String(messageId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Modulos Assistant conversation with all messages.
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation: async (conversationId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversation', 'conversationId', conversationId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getConversation', 'projectId', projectId)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get conversation messages by conversation ID.
         * @summary Get Conversation Messages
         * @param {string} projectId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessages: async (projectId: string, conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getConversationMessages', 'projectId', projectId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationMessages', 'conversationId', conversationId)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}/messages`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get mentionable items for Modulos Assistant input.  Returns items from the current project that match the search query. Can filter by concept type (control, evidence, framework, requirement). Searches by code and name, returning up to 10 results.  Parameters:     project_id: UUID of the project     query: Optional search query to filter items by name or code     concept_type: Concept type to filter by (control, evidence, framework, requirement)
         * @summary Get Mentions
         * @param {string} projectId 
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMentions: async (projectId: string, conceptType: MentionConceptType, query?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getMentions', 'projectId', projectId)
            // verify required parameter 'conceptType' is not null or undefined
            assertParamExists('getMentions', 'conceptType', conceptType)
            const localVarPath = `/modulos-assistant/projects/{project_id}/mentions`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (conceptType !== undefined) {
                localVarQueryParameter['concept_type'] = conceptType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Modulos Assistant conversations for a project.
         * @summary List Conversations
         * @param {string} projectId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversations: async (projectId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listConversations', 'projectId', projectId)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a query to a Modulos Assistant conversation.  This creates or continues a conversation session with the Modulos Assistant AI agent. Returns a status indicating whether the investigation was started.
         * @summary Query Conversation
         * @param {string} projectId 
         * @param {ConversationQueryRequest} conversationQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryConversation: async (projectId: string, conversationQueryRequest: ConversationQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('queryConversation', 'projectId', projectId)
            // verify required parameter 'conversationQueryRequest' is not null or undefined
            assertParamExists('queryConversation', 'conversationQueryRequest', conversationQueryRequest)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/query`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry the last valid state of a Modulos Assistant conversation.  Re-runs the agent from the last valid checkpoint without a new user message. Returns a status indicating whether the retry was started.
         * @summary Retry Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {ConversationRetryRequest} conversationRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryConversation: async (conversationId: string, projectId: string, conversationRetryRequest: ConversationRetryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('retryConversation', 'conversationId', conversationId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('retryConversation', 'projectId', projectId)
            // verify required parameter 'conversationRetryRequest' is not null or undefined
            assertParamExists('retryConversation', 'conversationRetryRequest', conversationRetryRequest)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}/retry`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationRetryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stream Modulos Assistant conversation events via SSE.  Access is checked before the stream opens, so a refused request gets its status code. Answers carry the id of their message as SSE id; a reconnect sends it back as `Last-Event-ID` and the answers after it are replayed before the live events.
         * @summary Stream Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {string | null} [lastEventID] Replay the answers after this message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamConversation: async (conversationId: string, projectId: string, lastEventID?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('streamConversation', 'conversationId', conversationId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('streamConversation', 'projectId', projectId)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}/stream`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/event-stream,application/json';

            if (lastEventID != null) {
                localVarHeaderParameter['Last-Event-ID'] = String(lastEventID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Modulos Assistant conversation.
         * @summary Update Conversation
         * @param {string} projectId 
         * @param {string} conversationId 
         * @param {EditConversation} editConversation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversation: async (projectId: string, conversationId: string, editConversation: EditConversation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateConversation', 'projectId', projectId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('updateConversation', 'conversationId', conversationId)
            // verify required parameter 'editConversation' is not null or undefined
            assertParamExists('updateConversation', 'editConversation', editConversation)
            const localVarPath = `/modulos-assistant/projects/{project_id}/conversations/{conversation_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editConversation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulosAssistantApi - functional programming interface
 */
export const ModulosAssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulosAssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * Create temporary evidence from a conversation message.
         * @summary Create Temp Evidence For Conversation
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTempEvidenceForConversation(conversationId: string, messageId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempEvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTempEvidenceForConversation(conversationId, messageId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.createTempEvidenceForConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Modulos Assistant conversation with all messages.
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversation(conversationId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Conversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversation(conversationId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.getConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get conversation messages by conversation ID.
         * @summary Get Conversation Messages
         * @param {string} projectId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationMessages(projectId: string, conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationMessages(projectId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.getConversationMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get mentionable items for Modulos Assistant input.  Returns items from the current project that match the search query. Can filter by concept type (control, evidence, framework, requirement). Searches by code and name, returning up to 10 results.  Parameters:     project_id: UUID of the project     query: Optional search query to filter items by name or code     concept_type: Concept type to filter by (control, evidence, framework, requirement)
         * @summary Get Mentions
         * @param {string} projectId 
         * @param {MentionConceptType} conceptType 
         * @param {string | null} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMentions(projectId: string, conceptType: MentionConceptType, query?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MentionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMentions(projectId, conceptType, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.getMentions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Modulos Assistant conversations for a project.
         * @summary List Conversations
         * @param {string} projectId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversations(projectId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversations(projectId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.listConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a query to a Modulos Assistant conversation.  This creates or continues a conversation session with the Modulos Assistant AI agent. Returns a status indicating whether the investigation was started.
         * @summary Query Conversation
         * @param {string} projectId 
         * @param {ConversationQueryRequest} conversationQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryConversation(projectId: string, conversationQueryRequest: ConversationQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryConversation(projectId, conversationQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.queryConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry the last valid state of a Modulos Assistant conversation.  Re-runs the agent from the last valid checkpoint without a new user message. Returns a status indicating whether the retry was started.
         * @summary Retry Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {ConversationRetryRequest} conversationRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryConversation(conversationId: string, projectId: string, conversationRetryRequest: ConversationRetryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationRetryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryConversation(conversationId, projectId, conversationRetryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.retryConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stream Modulos Assistant conversation events via SSE.  Access is checked before the stream opens, so a refused request gets its status code. Answers carry the id of their message as SSE id; a reconnect sends it back as `Last-Event-ID` and the answers after it are replayed before the live events.
         * @summary Stream Conversation
         * @param {string} conversationId 
         * @param {string} projectId 
         * @param {string | null} [lastEventID] Replay the answers after this message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamConversation(conversationId: string, projectId: string, lastEventID?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamConversation(conversationId, projectId, lastEventID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.streamConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Modulos Assistant conversation.
         * @summary Update Conversation
         * @param {string} projectId 
         * @param {string} conversationId 
         * @param {EditConversation} editConversation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConversation(projectId: string, conversationId: string, editConversation: EditConversation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Conversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConversation(projectId, conversationId, editConversation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulosAssistantApi.updateConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModulosAssistantApi - factory interface
 */
export const ModulosAssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulosAssistantApiFp(configuration)
    return {
        /**
         * Create temporary evidence from a conversation message.
         * @summary Create Temp Evidence For Conversation
         * @param {ModulosAssistantApiCreateTempEvidenceForConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidenceForConversation(requestParameters: ModulosAssistantApiCreateTempEvidenceForConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<TempEvidenceResponse> {
            return localVarFp.createTempEvidenceForConversation(requestParameters.conversationId, requestParameters.messageId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Modulos Assistant conversation with all messages.
         * @summary Get Conversation
         * @param {ModulosAssistantApiGetConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(requestParameters: ModulosAssistantApiGetConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Conversation> {
            return localVarFp.getConversation(requestParameters.conversationId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get conversation messages by conversation ID.
         * @summary Get Conversation Messages
         * @param {ModulosAssistantApiGetConversationMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessages(requestParameters: ModulosAssistantApiGetConversationMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationMessage>> {
            return localVarFp.getConversationMessages(requestParameters.projectId, requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get mentionable items for Modulos Assistant input.  Returns items from the current project that match the search query. Can filter by concept type (control, evidence, framework, requirement). Searches by code and name, returning up to 10 results.  Parameters:     project_id: UUID of the project     query: Optional search query to filter items by name or code     concept_type: Concept type to filter by (control, evidence, framework, requirement)
         * @summary Get Mentions
         * @param {ModulosAssistantApiGetMentionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMentions(requestParameters: ModulosAssistantApiGetMentionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MentionSearchResponse> {
            return localVarFp.getMentions(requestParameters.projectId, requestParameters.conceptType, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * List Modulos Assistant conversations for a project.
         * @summary List Conversations
         * @param {ModulosAssistantApiListConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversations(requestParameters: ModulosAssistantApiListConversationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationSummary>> {
            return localVarFp.listConversations(requestParameters.projectId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a query to a Modulos Assistant conversation.  This creates or continues a conversation session with the Modulos Assistant AI agent. Returns a status indicating whether the investigation was started.
         * @summary Query Conversation
         * @param {ModulosAssistantApiQueryConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryConversation(requestParameters: ModulosAssistantApiQueryConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationQueryResponse> {
            return localVarFp.queryConversation(requestParameters.projectId, requestParameters.conversationQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry the last valid state of a Modulos Assistant conversation.  Re-runs the agent from the last valid checkpoint without a new user message. Returns a status indicating whether the retry was started.
         * @summary Retry Conversation
         * @param {ModulosAssistantApiRetryConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryConversation(requestParameters: ModulosAssistantApiRetryConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationRetryResponse> {
            return localVarFp.retryConversation(requestParameters.conversationId, requestParameters.projectId, requestParameters.conversationRetryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stream Modulos Assistant conversation events via SSE.  Access is checked before the stream opens, so a refused request gets its status code. Answers carry the id of their message as SSE id; a reconnect sends it back as `Last-Event-ID` and the answers after it are replayed before the live events.
         * @summary Stream Conversation
         * @param {ModulosAssistantApiStreamConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamConversation(requestParameters: ModulosAssistantApiStreamConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<StreamConversation200Response> {
            return localVarFp.streamConversation(requestParameters.conversationId, requestParameters.projectId, requestParameters.lastEventID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Modulos Assistant conversation.
         * @summary Update Conversation
         * @param {ModulosAssistantApiUpdateConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversation(requestParameters: ModulosAssistantApiUpdateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Conversation> {
            return localVarFp.updateConversation(requestParameters.projectId, requestParameters.conversationId, requestParameters.editConversation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTempEvidenceForConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiCreateTempEvidenceForConversationRequest {
    readonly conversationId: string

    readonly messageId: string

    readonly projectId: string
}

/**
 * Request parameters for getConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiGetConversationRequest {
    readonly conversationId: string

    readonly projectId: string
}

/**
 * Request parameters for getConversationMessages operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiGetConversationMessagesRequest {
    readonly projectId: string

    readonly conversationId: string
}

/**
 * Request parameters for getMentions operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiGetMentionsRequest {
    readonly projectId: string

    readonly conceptType: MentionConceptType

    readonly query?: string | null
}

/**
 * Request parameters for listConversations operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiListConversationsRequest {
    readonly projectId: string

    readonly limit?: number

    readonly offset?: number
}

/**
 * Request parameters for queryConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiQueryConversationRequest {
    readonly projectId: string

    readonly conversationQueryRequest: ConversationQueryRequest
}

/**
 * Request parameters for retryConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiRetryConversationRequest {
    readonly conversationId: string

    readonly projectId: string

    readonly conversationRetryRequest: ConversationRetryRequest
}

/**
 * Request parameters for streamConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiStreamConversationRequest {
    readonly conversationId: string

    readonly projectId: string

    /**
     * Replay the answers after this message
     */
    readonly lastEventID?: string | null
}

/**
 * Request parameters for updateConversation operation in ModulosAssistantApi.
 */
export interface ModulosAssistantApiUpdateConversationRequest {
    readonly projectId: string

    readonly conversationId: string

    readonly editConversation: EditConversation
}

/**
 * ModulosAssistantApi - object-oriented interface
 */
export class ModulosAssistantApi extends BaseAPI {
    /**
     * Create temporary evidence from a conversation message.
     * @summary Create Temp Evidence For Conversation
     * @param {ModulosAssistantApiCreateTempEvidenceForConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTempEvidenceForConversation(requestParameters: ModulosAssistantApiCreateTempEvidenceForConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).createTempEvidenceForConversation(requestParameters.conversationId, requestParameters.messageId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Modulos Assistant conversation with all messages.
     * @summary Get Conversation
     * @param {ModulosAssistantApiGetConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversation(requestParameters: ModulosAssistantApiGetConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).getConversation(requestParameters.conversationId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get conversation messages by conversation ID.
     * @summary Get Conversation Messages
     * @param {ModulosAssistantApiGetConversationMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationMessages(requestParameters: ModulosAssistantApiGetConversationMessagesRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).getConversationMessages(requestParameters.projectId, requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get mentionable items for Modulos Assistant input.  Returns items from the current project that match the search query. Can filter by concept type (control, evidence, framework, requirement). Searches by code and name, returning up to 10 results.  Parameters:     project_id: UUID of the project     query: Optional search query to filter items by name or code     concept_type: Concept type to filter by (control, evidence, framework, requirement)
     * @summary Get Mentions
     * @param {ModulosAssistantApiGetMentionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMentions(requestParameters: ModulosAssistantApiGetMentionsRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).getMentions(requestParameters.projectId, requestParameters.conceptType, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Modulos Assistant conversations for a project.
     * @summary List Conversations
     * @param {ModulosAssistantApiListConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConversations(requestParameters: ModulosAssistantApiListConversationsRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).listConversations(requestParameters.projectId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a query to a Modulos Assistant conversation.  This creates or continues a conversation session with the Modulos Assistant AI agent. Returns a status indicating whether the investigation was started.
     * @summary Query Conversation
     * @param {ModulosAssistantApiQueryConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryConversation(requestParameters: ModulosAssistantApiQueryConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).queryConversation(requestParameters.projectId, requestParameters.conversationQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry the last valid state of a Modulos Assistant conversation.  Re-runs the agent from the last valid checkpoint without a new user message. Returns a status indicating whether the retry was started.
     * @summary Retry Conversation
     * @param {ModulosAssistantApiRetryConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryConversation(requestParameters: ModulosAssistantApiRetryConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).retryConversation(requestParameters.conversationId, requestParameters.projectId, requestParameters.conversationRetryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stream Modulos Assistant conversation events via SSE.  Access is checked before the stream opens, so a refused request gets its status code. Answers carry the id of their message as SSE id; a reconnect sends it back as `Last-Event-ID` and the answers after it are replayed before the live events.
     * @summary Stream Conversation
     * @param {ModulosAssistantApiStreamConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public streamConversation(requestParameters: ModulosAssistantApiStreamConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).streamConversation(requestParameters.conversationId, requestParameters.projectId, requestParameters.lastEventID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Modulos Assistant conversation.
     * @summary Update Conversation
     * @param {ModulosAssistantApiUpdateConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConversation(requestParameters: ModulosAssistantApiUpdateConversationRequest, options?: RawAxiosRequestConfig) {
        return ModulosAssistantApiFp(this.configuration).updateConversation(requestParameters.projectId, requestParameters.conversationId, requestParameters.editConversation, options).then((request) => request(this.axios, this.basePath));
    }
}

